import * as React from "react"
import { SwitchSeeker } from "ui-seeker/core"


export default function SwitchMinStay({ leftText, rightText, siteName, grid, ...props }) {

    return <div className="switch-price-night" style={{ display: 'flex', alignItems: 'center', height: '38px', marginLeft: 8 }}>
		{ leftText || '' }
		<SwitchSeeker {...props} />
		<span style={{ fontSize: 13, whiteSpace: 'nowrap' }}>{ rightText || 'Min. stay' }</span>
	</div>
}